import { memo } from 'react';
import DiffEditor from './DiffEditor.js';

var index = /*#__PURE__*/memo(DiffEditor);

export default index;
